import getReasonList from '../../shared/mixins/review-report.mixin'
import ReviewExamsMixin from '@/shared/mixins/review-report.mixin'

export default {
  name: 'ModalRevisarLaudo',
  mixins: [getReasonList, ReviewExamsMixin],
  props: {
    openDialog: {
      type: Boolean
    },

    icon: {
      type: String
    },

    title: {
      type: String
    },

    subTitle: {
      type: String
    },
    examId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      Reasons: [],
      selectedCancelReason: null,
      reportText: '',
      refresh: null
    }
  },
  components: {},
  watch: {
    openDialog(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetForm()
        this.dialog = true
        this.fetchReasonList()
      }
    }
  },

  methods: {
    confirmAction() {
      this.$emit('confirmAction')
      this.dialog = false
      // função de solicitar retificação do laudo
    },
    currentUser() {
      const user = this.getUser()
      let roleName = ''
      if (this.roles.length) {
        roleName = this.$i18n.t(`user_role.${this.$constants.TRANSLATION.ROLES[user.role.name]}`)
      }
      return {
        name: user.fullname,
        role: roleName
      }
    },
    fetchReasonList() {
      return this.getReasonList()
        .then((response) => {
          this.Reasons = response
        })
        .catch((error) => {
          console.error('Error fetching reasons:', error)
        })
    },
    async handleReviewReport() {
      try {
        const payload = {
          content: this.reportText || '',
          examId: this.examId,
          reasonId: this.selectedCancelReason,
          approved: false
        }
        await this.sendMaintainReport(payload)
        this.$root.$emit('toast', {
          message: this.$i18n.t('radio_report.successfully_sent'),
          type: 'success'
        })
      } catch (error) {
        this.$root.$emit('toast', {
          message: this.$i18n.t('radio_report.error_sending_report'),
          type: 'error'
        })
      } finally {
        this.$emit('refresh')
        this.dialog = false
        this.resetForm()
      }
    },
    resetForm() {
      this.selectedCancelReason = null
      this.reportText = ''
    },
  },
  computed: {
    isButtonDisabled() {
      return this.reportText.length < 10 || this.selectedCancelReason === null
    },
  },
}
